<template>
    <Modal v-model="show"
        width="85"
        :footer-hide="true"
        title="发货单"
		:scrollable="true"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <!-- <span class="title">送货单质检</span> -->
                    </div>
                    <div class="right-bar" style="margin-bottom:20px;" v-if="$checkAccessArray(['B','C','D'])&&preSaleDeliveryRecord.preSaleDeliveryRecordStatus!='关闭'">
						 <!-- <div style="margin-right: 20px;color:red;font-weight:bold;">提示：修改发货日期、发货方式、数量和单价后请点击保存按钮</div>
						 <Poptip v-if="showPoptip"
						    confirm
						    placement="left"
						    title="请确认信息是否无误？"
						    @on-ok="saveDetailInfo"
						    @on-cancel="cancel" style="margin-right: 20px;">
						    <Button type="primary">保存</Button>
						 </Poptip> -->
						 <Poptip v-if="showPoptip"
						        confirm
								placement="left"
						        title="是否已确认所有信息无误？"
						        @on-ok="ok"
						        @on-cancel="cancel" style="margin-right: 20px;">
						        <Button type="error">确认发货</Button>
						    </Poptip>
                        <Button type="success"
                            @click="printDeliveryRecord()">打印发货单</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="top"
					:rules="ruleValidate"
					>

                    <Row :gutter="16">
						<Col span="4">
						<FormItem label="发货单号">
						    <Input :value="preSaleDeliveryRecord.billCode"
						        readonly></Input>
						</FormItem>
						</Col>
                        <Col span="4">
                        <FormItem label="关联定金单号">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordRelateOrderRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="会员号">
                            <Input :value="preSaleDeliveryRecord.userName"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="会员电话">
                            <Input :value="preSaleDeliveryRecord.userExternalCustomerContactNumber"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="发货日期">
                            <Input v-model="sendDeliveryDate" :value="formatDateString(preSaleDeliveryRecord.preSaleDeliveryRecordDeliveryDate)"
                                ></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单时间">
                            <Input :value="formatDateTimeString(preSaleDeliveryRecord.preSaleDeliveryRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
						<Col span="4">
						<FormItem label="实际发货量">
						    <Input :value="preSaleDeliveryRecord.receiveQuantity"
						        readonly></Input>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="抛头/赠送率(%)">
							<Input :value="preSaleDeliveryRecord.additionalRate"
								readonly></Input>
						</FormItem>
						</Col>
						<Col span="4">
                        <FormItem label="本批发货量">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordTotalQuantity"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单人">
                            <Input :value="preSaleDeliveryRecord.billMaker"
                                readonly></Input>
                        </FormItem>
                        </Col>
						<Col span="4">
							<FormItem label="发货方式">
							   <RadioGroup v-model="preSaleDeliveryRecord.deliveryWays"
							       type="button"
							       size="large"
							       @on-change="onDeliveryWaysChange">
								   <Radio v-for="(item,index) in deliveryWaysList"
								       :key="item.val"
								       :label="item.val">{{ item.label }}
								   </Radio>
							   </RadioGroup>
							</FormItem>
						</Col>
						<Col span="4" v-show="showTransferStation">
							<FormItem label="转运站">
							   <Select :disabled="isShowUpdateDisBtn" v-model="preSaleDeliveryRecord.relateDistributionStationUuid" filterable clearable>
									<Option v-for="(item,index) in stationList" :value="item.distributionStationUuid" :key="item.distributionStationUuid">{{ item.distributionStationName }}</Option>
								</Select>
							</FormItem>
						</Col>
                        <Col span="4" v-show="showTransferStation">
                        	<FormItem label="当前转运站收运费" v-if="$checkAccessArray(['D','S'])">
                        		<Input v-model="preSaleDeliveryRecord.currentDeliveryFee"
                        			></Input>
                        	</FormItem>
                        </Col>
						<Col span="4" v-show="showLogistics">
							<FormItem label="物流单号">
								<Input v-model="preSaleDeliveryRecord.logisticsCode"
									></Input>
							</FormItem>
						</Col>
						<Col span="4"  v-show="showLogistics">
							<FormItem label="物流公司">
								<Input v-model="preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName"
									></Input>
							</FormItem>
						</Col>
						<Col span="4">
							<FormItem label="是否返回定金">
								<RadioGroup v-model="preSaleDeliveryRecord.isReturnDepositFee" type="button">
									<Radio :key="1" :label="1" >是</Radio>
									<Radio :key="0" :label="0" >否</Radio>
								</RadioGroup>
							</FormItem>
						</Col>
						<Col span="4" offset="16" v-if="isShowUpdateDisBtn">
							<Button type="info" @click="ShowDistributionStation">修改转运站</Button>
						</Col>
						<!-- <Col span="4">
							<FormItem
								label="选择用友部门"
								class="custom-required-field"
								v-if="preSaleDeliveryRecord.seedFarmName === '洋桔梗种苗部'"
							>
								<template #label>
								<span class="custom-asterisk">*</span>
								选择用友部门
								</template>
								<Select
									v-model="preSaleDeliveryRecord.deptYSType"
									filterable
									clearable
									@on-change="onDeptYSTypeChange"
									>
									<Option
										v-for="item in DEPT_YS_TYPE_OPERATION"
										:value="item.value"
										:key="item.value"
									>{{ item.label }}</Option>
								</Select>
							</FormItem>
						</Col> -->
                    </Row>
					<Row :gutter="16">
						<Col span="4">
						<FormItem label="客户经理">
						    <Input :value="preSaleDeliveryRecord.userCustomerManagerName"
						        readonly></Input>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="佣金比例">
						    <Input :value="preSaleDeliveryRecord.salesAssociateCommissionPercent"
						        readonly></Input>
						</FormItem>
						</Col>
						<Col span="8">
						<FormItem label="客户备注" v-if="$checkAccessArray(['S','B','D'])">
						    <Input :value="preSaleDeliveryRecord.customerMsg"
						        readonly type="textarea"></Input>
						</FormItem>
						</Col>
						<Col span="8">
						<FormItem label="撤销原因" v-if="$checkAccessArray(['S','B','D'])">
						    <Input :value="preSaleDeliveryRecord.cancelReason"
						        readonly type="textarea"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span="24">
							<!-- <div style="width: 100%;text-align: right;" v-if="$checkAccessArray(['B','C'])&&preSaleDeliveryRecord.preSaleDeliveryRecordStatus!='关闭'">
								<Poptip v-if="showPoptip"
								   confirm
								   placement="left"
								   title="以第一行品种的单价为准,是否将全部品种的单价改成一样？"
								   @on-ok="updatePreSalePlanPrice"
								   @on-cancel="cancel">
								   <Button type="error">批量修改单价</Button>
								</Poptip>

							</div> -->

							<div style="width: 100%;text-align: right;" v-if="$checkAccessArray(['B','C'])">
								<Poptip v-if="this.preSaleDeliveryRecord.preSaleDeliveryRecordStatus==-1"
								   confirm
								   placement="left"
								   title="请确认信息是否无误？"
								   @on-ok="updateOrder"
								   @on-cancel="cancel" style="text-align: left;margin-right: 10px;">
								   <Button type="info">批量保存修改</Button>
								</Poptip>
								<Poptip v-if="this.preSaleDeliveryRecord.preSaleDeliveryRecordStatus==0"
								   confirm
								   placement="left"
								   title="请确认信息是否无误？"
								   @on-ok="saveReceiveQuantity"
								   @on-cancel="cancel" style="text-align: left;">
								   <Button type="error">保存发货量</Button>
								</Poptip>
							</div>
							<FormItem>
								<div slot="label">
									<b>发货单明细</b>
								</div>
								<Table ref="productTable"
									size="small"
									:columns="productTable.columns"
									:data="preSaleDeliveryDetails"
									stripe
									border />
							</FormItem>
						</Col>
					</Row>
                </Form>
                </Col>
            </Row>

			<Modal v-model="distributionStation.Show" title="修改转运站" class-name="vertical-center-modal" width="400">
				  <Loading :isLoading="saveLoading"  />
					<Form label-position="top">
						<Row :gutter="16">
							<Col span="12">
							<FormItem label="选择转运站:">
								   <Select v-model="distributionStation.relateDistributionStationUuid" filterable clearable>
									<Option v-for="(item,index) in stationList" :value="item.distributionStationUuid" :key="item.distributionStationUuid">{{ item.distributionStationName }}</Option>
								</Select>
							</FormItem>
							</Col>
						</Row>
					</Form>
					<div slot="footer">
						<Button type="primary" @click="updateShippedDistributionStation">确认</Button>
						<Button type="error" @click="distributionStation.Show=false">取消</Button>
					</div>
			</Modal>
        </Card>

    </Modal>
</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import { DELIVERYWAYS_SELFMENTION, DELIVERYWAYS_TRANSFERSTATION, DELIVERYWAYS_LOGISTICS, deliveryWaysFormat } from '@/libs/baseModelFormat';
import { getPreSaleDeliveryRecord, printPreSaleDeliveryRecord, updatePreSaleDeliveryDetailByUuid, confirmPreSaleDeliveryByUuid, updatePreSaleDeliveryReceiveQuantity, UpdatePreSaleDelivery,
    getPreSaleDeliveryDefaultDistributionStation, updatePreSaleDeliveryShippedDistributionStation, getPreSaleDeliveryRelateStationList } from '@/api/modules/preSale-management/preSale-delivery';
import { getDistributionStationList } from '@/api/modules/distributionStation-management/distributionStationList';
import { DOWNLOAD_SERVER, FILE_SERVER } from '@/api/modules/files';
import { getUserInfoByToken } from '@/api/modules/rbac';
import { DEPT_YS_TYPE_OPERATION } from '@/view/common/pre-sale-delivery';
import { productQuantityIsRoundedMixin } from "@/view/mixins/ProductQuantityIsRounded.js";
import Loading from '@/components/loading/Loading.vue';
import search from '@/libs/search';
import { log } from 'vxe-table';
export default {
    name: 'PreSaleDeliveryDetail',
    mixins: [productQuantityIsRoundedMixin],
	   components: {
        Loading
    },
    data() {
        return {
            DEPT_YS_TYPE_OPERATION,
            showPoptip:true,
            sendDeliveryDate:'',
            showTransferStation:false,
            showLogistics:false,
            stationList: [],
            deliveryWaysList:[],
            show: false,
            innerSpin: false,
            orderUuid: '',
            preSaleDeliveryRecordUuid: '',
            preSaleDeliveryRecord: {
                deptYSType: 0
            },
            ruleValidate: {
                deliveryWaysList:[]
            },
            preSaleDeliveryDetails: [],
            productTable: {
                columns: [
                    {
					    title: '序号',
                        align: 'center',
                        width:'50',
					    render:(h, params) =>{
                            if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
								 h('span', '');
                            }
                            else{
                                return h('span', params.index+1);
                            }
					    }
                    },
                    { title: '品种编码', key: 'productCode', align: 'center' },
                    {
                        title: '品种名称', key: 'productName', align: 'center',
                        render: (h, params) => {
                            if (params.row.preSaleDeliveryDetailUuid) {
                                return	h('span', params.row.productName);
                            }
                            else if (params.row.unitName &&params.row.unitName!= '数量合计') {
                                if(params.row.unitName=='代金券'){
                                    return h('span', "");
                                }
                                return h('span', params.row.unitName);
                            }
                        }
                    },
                    { title: '单位', key: 'unitName', align: 'center',
                        render: (h, params) => {
                            if (params.row.preSaleDeliveryDetailUuid) {
                                return	h('span', params.row.unitName);
                            }
                            else if(params.row.unitName=='数量合计'){
                                return h('span', '合计');
                            }
                        }
				    },
                    {
                        title: '收款量',
                        align: 'center',
                        key: 'preSaleDeliveryDetailCollectionQuantity',
                        render: (h, params) => {
                            if (params.row.preSaleDeliveryDetailUuid) {
                                return	h('span', params.row.preSaleDeliveryDetailCollectionQuantity);
                            }
                            else if(params.row.unitName == '数量合计'){
							  return h('span', this.getSumTotalMoneyByColumName('preSaleDeliveryDetailCollectionQuantity', 2));
						  }
                        }
                    },
                    {
                        title: '实际发货量',
                        align: 'center',
                        key: 'additionalQuantity',
						   render: (h, params) => {
						   if(params.row.productCode&&params.row.productName&&params.row.unitName&&params.row.preSaleDeliveryRecordStatus<=0){
							   return h('InputNumber', {
								   props: {
									   value: parseFloat(params.row.additionalQuantity),
									   min: parseFloat(params.row.orderQuantity),
                                        //   max: parseFloat(params.row.preSaleDeliveryDetailCollectionQuantity),
									   precision:this.getUnitisRounded(params.row.unitName),
									   activeChange: false,
									   step: 1
								   },
								   style: {
									   textAlign: "center"
								   },
								   on: {
									   'on-change': (event) => {
										   params.row.additionalQuantity = event;
										   this.updateRow(params.row, 'additionalQuantity');
									   }
								   }
							   });
						   }
						   else if(params.row.preSaleDeliveryDetailUuid){
							  return h('span', parseFloat(params.row.additionalQuantity));
						  }
						  else if(params.row.unitName == '数量合计'){
							  return h('span', this.getSumTotalMoneyByColumName('additionalQuantity', 2));
						  }

                        }
                    },
                    {
					    title: '本批发货量',
                        align: 'center',
					    key: 'orderQuantity',
                        render: (h, params) => {

                            if (params.row.unitName == '数量合计') {
                                return h('span', this.getSumTotalMoneyByColumName('orderQuantity', 2));
                            }
                            else if(params.row.preSaleDeliveryDetailUuid) {
                                if(this.preSaleDeliveryRecord.preSaleDeliveryRecordStatus==-1){
                                    return h('InputNumber', {
                                        props: {
										 value:parseFloat(params.row.orderQuantity),
										 max: parseFloat(params.row.preSaleDeliveryDetailCollectionQuantity),
                                            min:this.getUnitisRounded(params.row.unitName)==0?1:0.01,
                                            activeChange:false,
                                            step: 1,
                                            precision:this.getUnitisRounded(params.row.unitName)
									 },
									 style:{
										 textAlign: "center"
									 },
									 on: {
                                            'on-change': (event) => {
											 params.row.orderQuantity = event;
											 this.updateRow(params.row, 'orderQuantity', 2);
											 if(event>params.row.additionalQuantity){
                                                    params.row.additionalQuantity = event;
                                                    this.updateRow(params.row, 'additionalQuantity', 2);
											 }
											  this.getTotalMoney(params.row);
                                            }
                                        }
                                    });
                                }
                                else{
                                    return h('span', parseFloat(params.row.orderQuantity));
                                }
                            }
                            else if (params.row.unitName) {
                                return h('span', params.row.orderQuantity);
                            }
                            else {
                                return h('span', '');
                            }
                        }
                    },
                    {
					    title: '单价',
                        align: 'center',
					    key: 'preSalePlanPrice',
                        render: (h, params) => {
                            if (params.row.preSaleDeliveryDetailUuid) {
                                if(this.preSaleDeliveryRecord.preSaleDeliveryRecordStatus!=-1){
                                    return	h('span', params.row.preSalePlanPrice);
                                }
                                else{
                                    return h('InputNumber', {
                                        props: {
                                            value:parseFloat(params.row.preSalePlanPrice),
                                            min: 0,
                                            activeChange:false,
                                            step: 0.01
									 },
									 style:{
										 textAlign: "center"
									 },
									 on: {
                                            'on-change': (event) => {
											 params.row.preSalePlanPrice = event;
											 this.updateRow(params.row, 'preSalePlanPrice');
											  this.getTotalMoney(params.row);
                                            }
                                        }
                                    });
                                }

                            }
                        }

                    },
                    {
                        title: '金额', key: 'totalMoney', align: 'center',
                        render: (h, params) => {
                            if (params.row.unitName == '数量合计') {
                                return h('span', this.getSumTotalMoneyByColumName('totalMoney', 2));
                            }
                            else if (!params.row.preSaleDeliveryDetailUuid) {
                                return h('span', '');
                            }
                            else {
                                return h('span', params.row.totalMoney);
                            }
                        }
                    },
                    {
                        title: '商品优惠', key: 'preSaleDeliveryDetailProductUnitPrice', align: 'center',
                        render: (h, params) => {
                            if (params.row.preSaleDeliveryDetailUuid) {
							  return	h('span', params.row.preSaleDeliveryDetailProductUnitPrice);
                            }
                        }
                    },
                    {
                        title: '客户优惠', key: 'preSaleDeliveryDetailCustomerUnitPrice', align: 'center',
                        render: (h, params) => {
                            if (params.row.preSaleDeliveryDetailUuid) {
                                return	h('span', params.row.preSaleDeliveryDetailCustomerUnitPrice);
                            }
                        }
                    },
                    {
                        title: '其它优惠', key: 'preSaleDeliveryDetailArtificialUnitAmount', align: 'center',
                        render: (h, params) => {
                            if (params.row.preSaleDeliveryDetailUuid) {
                                if(this.preSaleDeliveryRecord.preSaleDeliveryRecordStatus!=-1){
                                    return	h('span', params.row.preSaleDeliveryDetailArtificialUnitAmount);
                                }
                                else{
                                    return h('InputNumber', {
                                        props: {
                                            value:parseFloat(params.row.preSaleDeliveryDetailArtificialUnitAmount),
                                            min: 0,
                                            activeChange:false,
                                            step: 0.01
									 },
									 style:{
										 textAlign: "center"
									 },
									 on: {
                                            'on-change': (event) => {
											 params.row.preSaleDeliveryDetailArtificialUnitAmount = event;
											 this.updateRow(params.row, 'preSaleDeliveryDetailArtificialUnitAmount');

                                            }
                                        }
                                    });
                                }
						    //	return	h('span', params.row.preSaleDeliveryDetailArtificialUnitAmount);

                            }
                        }
                    },
                    {
                        title: '结算单价', key: 'SettlementUnitrice', align: 'center',
                        render: (h, params) => {
                            if(params.row.preSaleDeliveryDetailUuid){
                                return h('span', this.getSettlementUnitrice(params.row));
                            }
                            else if (params.row.unitName&&params.row.unitName!='数量合计') {
                                if(params.row.unitName=='代金券'){
                                    return h('span', params.row.unitName);
                                }
                                return h('span', params.row.preSalePlanPrice);
                            }
                            else if (params.row.preSalePlanPrice=='总额') {
                                return h('span', '总额');
                            }
						   else{
                                h('span', '');
                            }
                        }
                    },
                    {
                        title: '优惠金额', key: 'getSettlementDiscount', align: 'center',
                        render: (h, params) => {
                            if (params.row.unitName == '数量合计') {
                                return h('span', this.getSumSettlementDiscount());
                            }
                            else if (params.row.preSaleDeliveryDetailUuid) {
                                return h('span', this.getSettlementDiscount(params.row));

                            }
                            else {
                                return h('span', '');
                            }
                        }
                    },
                    {
                        title: '代金券', key: 'voucherAmount', align: 'center',
                        render: (h, params) => {
                            if (params.row.preSaleDeliveryDetailUuid) {
                                return	h('span', params.row.voucherAmount);
                            }
                            if(params.row.unitName=='数量合计'){
                                return h('span', this.getSumSettlemenVoucherAmount());
                            }
                        }
                    },
                    { title: '结算金额', key: 'getSettlementMoney', align: 'center',
                        render: (h, params) => {
                            if(params.row.unitName=='数量合计'){
                                return h('span', this.getSumSettlementMoney());
                            }
                            else if (params.row.preSalePlanPrice == '总额') {
                                return h('span', this.getPaymentAmount(params.row.totalMoney));
                            }
                            else if (!params.row.preSaleDeliveryDetailUuid) {
                                return h('span', parseFloat(parseFloat(params.row.totalMoney).toFixed(2)));
                            }
                            else {
                                return h('span', this.getSettlementMoney(params.row));
                            }
                        }
                    },
                    {
						    title: '操作',
						    key: 'action',
						    align: 'center',
						    width: 60,
						    render: (h, params) => {
                            return h('div', [
									    h('Button', {
									        props: {
									            type: 'text',
									            size: 'small',
									            shape: 'circle'
									        },
                                    style:{
                                        visibility: this.preSaleDeliveryRecord.preSaleDeliveryRecordStatus==-1&& params.row.preSaleDeliveryDetailUuid&&this.preSaleDeliveryDetails.filter(item=>item.preSaleDeliveryDetailUuid).length>1? 'visible' : 'hidden'
                                    },
                                    on: {
											    click: () => {
											        this.cancelProduct(params.row);
											    }
                                    }
									    }, '撤销')
                            ]);

						    }
                    }
                ]
            },
            distributionStation:{
                Show:false,
                relateDistributionStationUuid:''
            },
            distributionStationIsNoShipped:false,   //转运站是否未发货，是否可以修改已发货的转运站用到
            saveLoading:false
        };
    },
    mounted() {

    },
    computed: {
        isShowUpdateDis(){
            if(this.preSaleDeliveryRecord.preSaleDeliveryRecordStatus!=1){
                return false;
			  }
            if(!this.$checkAccessArray(['B'])){
                return false;
			  }
			  let sendtime=new Date(this.preSaleDeliveryRecord.preSaleDeliveryRecordDeliveryDate);
			  let now=new Date();
            let diff= now.getTime()-sendtime.getTime();
			  if(diff>24 * 60 * 60 * 1000){
                return false;
			  }
			  return true;
        },
        //是否显示修改转运站按钮
        isShowUpdateDisBtn(){
			  return this.isShowUpdateDis&&this.distributionStationIsNoShipped;
        }
    },
    methods: {
        //获取列表中的产品列表
        getDetailList() {
            let list = this.preSaleDeliveryDetails.filter(item => item.preSaleDeliveryDetailUuid);
            return list;
        },

        //计算合计金额,下单量，收款量
        getSumTotalMoneyByColumName(columnName, dig=0) {
            let list = this.getDetailList().map(x =>parseFloat(x[columnName]));
            let reslut = list.reduce((a, b) => a + b, 0)
            return parseFloat(reslut.toFixed(dig));
        },
	   //计算结算单价
	   getSettlementUnitrice(row){
		 let isNullAsZero=value=>value?value:0;
            let result=(parseFloat(row.preSalePlanPrice)-isNullAsZero(row.preSaleDeliveryDetailArtificialUnitAmount)-isNullAsZero(row.preSaleDeliveryDetailProductUnitPrice)-isNullAsZero(row.preSaleDeliveryDetailCustomerUnitPrice)).toFixed(4);
            return parseFloat(result);
        },
        //计算折扣金额
        getSettlementDiscount(row) {
            let isNullAsZero=value=>value?value:0;
            let result = ((isNullAsZero(row.preSaleDeliveryDetailArtificialUnitAmount)+isNullAsZero(row.preSaleDeliveryDetailProductUnitPrice)+isNullAsZero(row.preSaleDeliveryDetailCustomerUnitPrice)) * row.orderQuantity).toFixed(2);
            return parseFloat(result);
        },

		 //计算结算金额   结算单价(单价 - 其它优惠)*收款量-代金券金额
        getSettlementMoney(row) {
            let result = (this.getSettlementUnitrice(row) * row.orderQuantity - row.voucherAmount).toFixed(2);
            return parseFloat(result);
        },
        //计算合计折扣金额
        getSumSettlementDiscount() {
            let list = this.getDetailList();
            let reslut = list.reduce((a, b) => a + this.getSettlementDiscount(b), 0);
            return parseFloat(reslut.toFixed(2));
        },
        // 计算合计代金券金额
        getSumSettlemenVoucherAmount(){
            let list = this.getDetailList();
            let result = list.reduce((a, b) => a + b.voucherAmount, 0);
            return parseFloat(result.toFixed(2));
        },
        //计算合计结算金额
        getSumSettlementMoney() {
            let list = this.getDetailList();
            let result = list.reduce((a, b) => a + this.getSettlementMoney(b), 0);
            return parseFloat(result.toFixed(2));
        },
        //撤销
        cancelProduct(row) {

            this.preSaleDeliveryDetails = this.preSaleDeliveryDetails.filter(item => item.preSaleDeliveryDetailUuid != row.preSaleDeliveryDetailUuid);
            this.preSaleDeliveryRecord.orderItmeList = this.preSaleDeliveryDetails;
        },

        getUserInfo() {
            getUserInfoByToken().then(res => {
                if (res.code === 0) {
                    this.preSaleDeliveryRecord.billMaker = res.data.basicUserInfo.personName;
                }
            });
        },
        // updateRow(row){
        // 	this.preSaleDeliveryDetails.forEach(item =>{
        // 		if(row.preSaleDeliveryDetailUuid==item.preSaleDeliveryDetailUuid){
        // 			item.additionalQuantity=row.additionalQuantity;
        // 		}
        // 	});
        // },
        getRowByDetailUuid(row){
            return this.preSaleDeliveryDetails.find(item => row.preSaleDeliveryDetailUuid == item.preSaleDeliveryDetailUuid);
        },
        updateRow(row, cloumnName) {
            let detail = this.getRowByDetailUuid(row);
            detail[cloumnName] = row[cloumnName];
        },
        //计算每行金额
        getTotalMoney(row) {
            let detail = this.getRowByDetailUuid(row);
            let orderQuantity=detail.orderQuantity?parseFloat(detail.orderQuantity):0;
            detail.totalMoney=parseFloat((orderQuantity*detail.preSalePlanPrice).toFixed(2));
        },
        updatePreSalePlanPrice(){
            let preSalePlanPrice=this.preSaleDeliveryDetails[0].preSalePlanPrice;
            this.preSaleDeliveryDetails.forEach(item =>{
                if(item.productName){
                    item.preSalePlanPrice=preSalePlanPrice;
                }
            });
        },
        //计算总额
        getPaymentAmount() {
            let row1 = this.preSaleDeliveryDetails.find(item => item.unitName == '手动录入包装费');
            let row2 = this.preSaleDeliveryDetails.find(item => item.unitName == '手动录入配送费');
            let row3 = this.preSaleDeliveryDetails.find(item => item.unitName == '包装费');
            let row4 = this.preSaleDeliveryDetails.find(item => item.unitName == '配送费');
            let getTotalMoney = a => a ? a.totalMoney : 0;
            let result = this.getSumSettlementMoney() + getTotalMoney(row1) + getTotalMoney(row2) + getTotalMoney(row3) + getTotalMoney(row4);
            return parseFloat(result.toFixed(2));
        },
        saveReceiveQuantity(){
            this.preSaleDeliveryRecord.orderItmeList.forEach(item =>{
				  this.preSaleDeliveryDetails.forEach(e =>{
					  if(item.preSaleDeliveryDetailUuid&&item.preSaleDeliveryDetailUuid==e.preSaleDeliveryDetailUuid){
						  item.additionalQuantity = e.additionalQuantity;
					  }
				  });
            });
            this.innerSpin = true;
            updatePreSaleDeliveryReceiveQuantity({ preSaleDeliveryRecordVO:this.preSaleDeliveryRecord }).then(res => {
				  this.innerSpin = false;
				  if (res.code === 0) {
					  this.innerSpin = true;
					  getPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid:this.preSaleDeliveryRecordUuid, isSign:2 }).then(res => {
						  this.innerSpin = false;
						  if (res.code === 0) {
							  this.preSaleDeliveryRecord = res.data.recordList[0];
							  this.preSaleDeliveryDetails = res.data.recordList[0].orderItmeList;
                            if (this.showPoptip && this.$checkAccessArray(['B']) && !this.preSaleDeliveryRecord.relateDistributionStationUuid) {
                                let data = { preSaleDeliveryRecordUuid: this.preSaleDeliveryRecord.preSaleDeliveryRecordUuid };
                                getPreSaleDeliveryDefaultDistributionStation(data).then(res => {
                                    if (res.code == 0 && res.data) {
                                        this.preSaleDeliveryRecord.relateDistributionStationUuid = res.data;
                                    }
                                });
                            }
							  this.$parent.getMainTableRecords();
							  this.$Message.success('修改的信息保存成功！');

						  }
					  }).catch(() => {
						  this.innerSpin = false;
					  });

				  }
            });
        },
        saveDetailInfo(){
		  let sendDeliveryDateNew=this.sendDeliveryDate+" 00:00:00";
		  this.preSaleDeliveryRecord.sendProductDate=sendDeliveryDateNew;
		  this.preSaleDeliveryRecord.orderItmeList.forEach(item =>{
			  this.preSaleDeliveryDetails.forEach(e =>{
				  if(item.preSaleDeliveryDetailUuid&&item.preSaleDeliveryDetailUuid==e.preSaleDeliveryDetailUuid){
					  item.orderQuantity = e.orderQuantity;
					  item.preSalePlanPrice = e.preSalePlanPrice;
				  }
			  });
		  });
		  this.innerSpin = true;
		  updatePreSaleDeliveryDetailByUuid({ preSaleDeliveryRecordVO:this.preSaleDeliveryRecord }).then(res => {
			  this.innerSpin = false;
			  if (res.code === 0) {
				  this.innerSpin = true;
				  getPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid:this.preSaleDeliveryRecordUuid, isSign:2 }).then(res => {
					  this.innerSpin = false;
					  if (res.code === 0) {
						  this.preSaleDeliveryRecord = res.data.recordList[0];
						  this.preSaleDeliveryDetails = res.data.recordList[0].orderItmeList;
						  this.$parent.getMainTableRecords();
						  this.$Message.success('修改的信息保存成功！');

					  }
				  }).catch(() => {
					  this.innerSpin = false;
				  });

			  }
		  });
        },
        updateOrder(){
            let data= {
                ...this.preSaleDeliveryRecord,
                orderItmeList:this.preSaleDeliveryRecord.orderItmeList.filter(x=>x.preSaleDeliveryDetailUuid)
            };
            this.$Modal.confirm({
                title: "是否批量修改发货单？",
                content: "",
                onOk: async () => {
                    this.innerSpin = true;
				   let res=	await UpdatePreSaleDelivery({ preSaleDeliveryRecordVO: data });
				   this.innerSpin = false;
                    if (res.code === 0) {
					   this.innerSpin = true;
                        getPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid: this.preSaleDeliveryRecordUuid, isSign: 2 }).then(res => {
                            this.innerSpin = false;
                            if (res.code === 0) {
                                this.preSaleDeliveryRecord = res.data.recordList[0];
                                this.preSaleDeliveryDetails = res.data.recordList[0].orderItmeList;
                                this.$parent.getMainTableRecords();
                                this.$Message.success('修改的信息保存成功！');

                            }
                        });
                    }
                    else {
                        //	this.$Message.error(res.message);

                        this.$Message.error({
                            content: res.message,
                            duration: 2
                        });
                    }

                }
            });
        },
        onDeliveryWaysChange(val){
            this.showTransferStation = false;
            this.showLogistics = false;
            if(val==1||val==0){
                this.showTransferStation = true;
            }
            else if(val==2){
                this.showLogistics = true;
            }
        },
        ok() {
            // console.log("this.preSaleDeliveryRecord.deliveryWays="+this.preSaleDeliveryRecord.deliveryWays);
            if(this.preSaleDeliveryRecord.deliveryWays==1||this.preSaleDeliveryRecord.deliveryWays==0){
                if(this.preSaleDeliveryRecord.relateDistributionStationUuid==null||this.preSaleDeliveryRecord.relateDistributionStationUuid==''||this.preSaleDeliveryRecord.relateDistributionStationUuid==undefined){
                    console.log("this.preSaleDeliveryRecord.deliveryWaysAAA="+this.preSaleDeliveryRecord.deliveryWays);
                    this.$Message.info('请选择转运站,转运站不能为空！');
                    return;
                }
            }
            // console.log("this.preSaleDeliveryRecord.deliveryWaysBBB="+this.preSaleDeliveryRecord.deliveryWays);
            if(this.preSaleDeliveryRecord.deliveryWays==2){
                if(this.preSaleDeliveryRecord.logisticsCode==null||this.preSaleDeliveryRecord.logisticsCode==''||this.preSaleDeliveryRecord.logisticsCode==undefined){
                    this.$Message.info('发货方式为物流，请填写物流单号');
                    return;
                }
                if(this.preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName==null||this.preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName==''||this.preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName==undefined){
                    this.$Message.info('发货方式为物流，请填写物流公司');
                    return;
                }
            }
            this.innerSpin = true;
            confirmPreSaleDeliveryByUuid({ preSaleDeliveryRecordUuid:this.orderUuid, isReturnDepositFee:this.preSaleDeliveryRecord.isReturnDepositFee,
                deliveryWays:this.preSaleDeliveryRecord.deliveryWays, shippingNo:this.preSaleDeliveryRecord.logisticsCode,
                shippingCompany:this.preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName,
                stationUuid:this.preSaleDeliveryRecord.relateDistributionStationUuid,
                // receiveQuantity:this.preSaleDeliveryRecord.receiveQuantity,
                currentDeliveryFee:this.preSaleDeliveryRecord.currentDeliveryFee }).then(res => {
				  if (res.code === 0) {
					  this.showPoptip=false;
					  this.$parent.getMainTableRecords();
					  this.innerSpin = false;
					  this.$Message.success('确认发货成功！');
					  this.show = false;
				  }
				  else {
					  this.innerSpin = false;
					  this.$Message.info(res.message);
				  }
            });
        },
        cancel() {
		    this.$Message.info('请再次确认信息');
        },
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        getProductPlan(){

        },
        init() {
            this.deliveryWaysList = [];
            this.deliveryWaysList.push({ val: DELIVERYWAYS_SELFMENTION, label: deliveryWaysFormat(DELIVERYWAYS_SELFMENTION) });
            this.deliveryWaysList.push({ val: DELIVERYWAYS_TRANSFERSTATION, label: deliveryWaysFormat(DELIVERYWAYS_TRANSFERSTATION) });
            this.deliveryWaysList.push({ val: DELIVERYWAYS_LOGISTICS, label: deliveryWaysFormat(DELIVERYWAYS_LOGISTICS) });
            getDistributionStationList({}).then(res => {
			    if (res.code === 0) {
                    if(res.data.stationList.length>0){
                        this.stationList = res.data.stationList;
                    }
			    }
            });

            this.getPreSaleDeliveryRecordByUuid();

        },
        getPreSaleDeliveryRecordByUuid() {
            if (this.orderUuid) {
                this.preSaleDeliveryRecordUuid = this.orderUuid;

                this.innerSpin = true;
                getPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid: this.preSaleDeliveryRecordUuid, isSign: 2 }).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        if (res.data.recordList.length > 0) {
                            this.showPoptip = res.data.recordList[0].isShowDeliveryBtn;
                            this.onDeliveryWaysChange(res.data.recordList[0].deliveryWays);
                            this.sendDeliveryDate = formatDateString(res.data.recordList[0].preSaleDeliveryRecordDeliveryDate);
                            this.preSaleDeliveryRecord = res.data.recordList[0];
                            this.preSaleDeliveryDetails = res.data.recordList[0].orderItmeList;
                            if (this.$checkAccessArray(['B', 'C', 'D']) && !this.preSaleDeliveryRecord.billMaker) {
                                this.getUserInfo();
                            }
                            if (this.showPoptip && this.$checkAccessArray(['B']) && !this.preSaleDeliveryRecord.relateDistributionStationUuid) {
                                let data = { preSaleDeliveryRecordUuid: this.preSaleDeliveryRecord.preSaleDeliveryRecordUuid };
                                getPreSaleDeliveryDefaultDistributionStation(data).then(res => {
                                    if (res.code == 0 && res.data) {
                                        this.preSaleDeliveryRecord.relateDistributionStationUuid = res.data;
                                    }
                                });
                            }
                            this.getPreSaleDeliveryRelateStationList();
                        }
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            };
        },
        formatDateString,
        formatDateTimeString,
        printDeliveryRecord() {
            this.$showGlobalSpin();
            printPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid:this.preSaleDeliveryRecordUuid }).then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    window.open(DOWNLOAD_SERVER + res.data.url, "_blank");
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        },
        onDeptYSTypeChange(selectedValue){
            this.$set(this.preSaleDeliveryRecord, 'deptYSType', selectedValue);
        },
        ShowDistributionStation(){
            this.distributionStation.Show=true;
            this.distributionStation.relateDistributionStationUuid=this.preSaleDeliveryRecord.relateDistributionStationUuid;
        },
        updateShippedDistributionStation(){
            this.saveLoading = true;
		 let data={ preSaleDeliveryRecordUuid:this.preSaleDeliveryRecord.preSaleDeliveryRecordUuid, distributionStationUuid:this.distributionStation.relateDistributionStationUuid };
            updatePreSaleDeliveryShippedDistributionStation(data).then(res=>{
                this.saveLoading = false;
                if(res.code==0){
               	this.$Message.info('修改成功');
                    this.getPreSaleDeliveryRecordByUuid();
                    this.distributionStation.Show=false;
                }
                else{
	            this.$Message.err(res.message);
                }
		   }).catch(() => {
                this.saveLoading = false;
            });
        },
        getPreSaleDeliveryRelateStationList() {
            if (this.isShowUpdateDis) {
                let data = { deliveryId: this.preSaleDeliveryRecord.preSaleDeliveryRecordUuid };
                getPreSaleDeliveryRelateStationList(data).then(res => {
                    if (res.code == 0) {
                        if (res.data && res.data.length == 1) {
                            this.distributionStationIsNoShipped = true;
                        }
                    }
                });
            }
        }
    }
};
</script>

<style scoped>
	.ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{height:32px;line-height:32px;font-size:12px;padding:0px 10px;}
	.ivu-table-cell input{text-align: center;}

	/* 自定义红色星号 */
	.custom-asterisk {
	color: red;
	margin-right: 4px;
	}

</style>
